import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/Button';
interface CTABandProps {
  title: string;
  description: string;
  primaryButtonText: string;
  primaryButtonLink: string;
  secondaryButtonText?: string;
  secondaryButtonLink?: string;
  isExternalPrimary?: boolean;
}
export function CTABand({
  title,
  description,
  primaryButtonText,
  primaryButtonLink,
  secondaryButtonText,
  secondaryButtonLink,
  isExternalPrimary = false
}: CTABandProps) {
  const hasContent = title || description;
  return <div className="bg-primary-dark text-white py-16 md:py-24 relative overflow-hidden" data-id="element-335">
      <div className="absolute top-0 right-0 w-[400px] h-[400px] bg-primary rounded-full blur-[80px] opacity-50 -translate-y-1/2 translate-x-1/3 pointer-events-none" data-id="element-336" />
      <div className="absolute bottom-0 left-0 w-[300px] h-[300px] bg-brand-orange rounded-full blur-[80px] opacity-20 translate-y-1/2 -translate-x-1/3 pointer-events-none" data-id="element-337" />

      <div className="container relative z-10 text-center max-w-4xl mx-auto" data-id="element-338">
        {hasContent && <>
            {title && <h2 className="font-heading text-4xl md:text-5xl font-extrabold mb-6 tracking-tight" data-id="element-339">
                {title}
              </h2>}
            {description && <p className="text-lavande text-xl md:text-2xl mb-12 leading-relaxed font-medium" data-id="element-340">
                {description}
              </p>}
          </>}
        <div className={`flex flex-col sm:flex-row items-center justify-center gap-6 ${!hasContent ? 'mt-0' : ''}`} data-id="element-341">
          {isExternalPrimary ? <Button size="lg" className="w-full sm:w-auto bg-brand-orange hover:bg-[#E67E22] text-white text-lg px-10 py-7 shadow-xl" asChild data-id="element-342">
              <a href={primaryButtonLink} target="_blank" rel="noopener noreferrer" data-id="element-343">
                {primaryButtonText}
              </a>
            </Button> : <Button size="lg" className="w-full sm:w-auto bg-brand-orange hover:bg-[#E67E22] text-white text-lg px-10 py-7 shadow-xl" asChild data-id="element-344">
              <Link to={primaryButtonLink} data-id="element-345">{primaryButtonText}</Link>
            </Button>}

          {secondaryButtonText && secondaryButtonLink && <Button size="lg" variant="outline" className="w-full sm:w-auto bg-transparent border-white/40 text-white hover:bg-white hover:text-primary-dark text-lg px-8 py-7" asChild data-id="element-346">
              <Link to={secondaryButtonLink} data-id="element-347">{secondaryButtonText}</Link>
            </Button>}
        </div>
      </div>
    </div>;
}